import { lazy, Suspense } from 'react';
import type { RouteObject } from 'react-router';
import { PageLoader } from '@dezza/ui';

const StatsPage = lazy(() => import('./StatsPage'));

/** Rotas desta área (dentro do shell autenticado). */
export const routes: RouteObject[] = [
  {
    path: 'estatisticas',
    element: (
      <Suspense fallback={<PageLoader />}>
        <StatsPage />
      </Suspense>
    ),
  },
];

/** Rotas protegidas sem o shell (ex.: impressão). */
export const fullscreenRoutes: RouteObject[] = [];
